import { useDispatch, useSelector } from 'react-redux'
import { useCallback, useContext, useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import useLineItemDetails from './useLineItemDetails'

import { validateAd } from '../../../../../../modules/actions/ads'
import { selectedFacebookAdAccountSelector } from '../../../../../../modules/selectors/adAccounts'

import { AdFacebookCreateContext } from '../../../../formsContexts/AdFacebookCreateFormContextProvider'
import { FACEBOOK_PLATFORM } from '../../../../../../constants/selectLists/platformList'
import { transformValuesToBE } from '../formatters'

// FB does not currently have an endpoint to get valid domains linked to a pixel,
// therefore we first need to test the ad creation using the click through link's
// 1st and 2nd level domain with a validation check
export default function useAdValidationRequest(values, selectedApplicationId) {
  const { t } = useTranslation()
  const dispatch = useDispatch()

  const { id: selectedAdAccountId } = useSelector(selectedFacebookAdAccountSelector)
  const { lineItem } = useContext(AdFacebookCreateContext)

  const { lineItemId } = useLineItemDetails()

  const platformUtmCode = t('platformUtmCode')

  const makeValidationRequest = useCallback(() => {
    dispatch(
      validateAd(
        transformValuesToBE({
          values,
          selectedAdAccountId,
          adSetId: lineItemId,
          platformUtmCode,
          validateOnly: true,
          lineItem,
          selectedApplicationId
        }),
        FACEBOOK_PLATFORM
      )
    )
  }, [dispatch, values, lineItemId, platformUtmCode, selectedAdAccountId, lineItem, selectedApplicationId])

  return useMemo(() => makeValidationRequest, [makeValidationRequest])
}
